module.exports = __webpack_public_path__ + "1-19.png?16115763c1321d747a540c6b27507e3c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1-19.png
// module id = 96
// module chunks = 0